import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { AppUpdateService } from '@/services/app-update/app-update.service';
import { APIVersionService } from '@/services/api-version/api-version.service';

@Component({
  selector: 'app-update-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe],
  templateUrl: './app-update-banner.component.html',
  styleUrl: './app-update-banner.component.scss',
})
export class AppUpdateBannerComponent {
  private readonly apiVersion = inject(APIVersionService);
  private readonly appUpdate = inject(AppUpdateService);

  private readonly updateAvailable = this.apiVersion.updateAvailable;
  private readonly state = this.appUpdate.state;
  protected readonly downloading = computed(
    () =>
      this.state() === 'downloading' ||
      (this.state() === 'checking' && this.updateAvailable())
  );
  protected readonly busy = computed(
    () => this.downloading() || this.state() === 'reloading'
  );
  protected readonly ready = computed(() => this.state() === 'ready');
  protected readonly show = computed(
    () => this.updateAvailable() || this.busy() || this.ready()
  );

  protected apply(): void {
    void this.appUpdate.reloadNow();
  }
}
